/**
 * Utility class for creating notifications in the site.
 *
 * Notifications are created using the plugin Noty
 */
define([
    'jquery',
    'noty'
], function($, noty) {
    'use strict';

    return {

        /**
         * Create a success notification.
         *
         * The notification will timeout
         *
         * @param {string} message The success message to display in the notification
         * @param {int}    timeout [Optional] The time, in milliseconds, to display the notification. Default 5000ms (5s)
         *
         * @returns null
         */
        createSuccessNotification: function(message, timeout) {
            timeout = typeof timeout !== 'undefined' ? timeout : 3000;

            var n = this.createNotification({
                text: message,
                type: 'success'
            });

            // Set timeout to close the notification
            window.setTimeout(function() {
                n.close();
            }, timeout);
        },

        /**
         * Create an error notification
         *
         * This notification will not timeout, the user will need to manually clear it, as a way of acknowledging the error
         *
         * @param {string} message The error message to display
         * @param {int}    timeout [Optional] The time, in milliseconds, to display the notification. Default 5000ms (5s)
         *
         * @return null
         */
        createErrorNotification: function(message, timeout) {
            timeout = typeof timeout !== 'undefined' ? timeout : 3000;

            var n = this.createNotification({
                text: message,
                type: 'error'
            });

            // Set timeout to close the notification
            window.setTimeout(function() {
                n.close();
            }, timeout);
        },

        /**
         * Create a Noty notification
         *
         * @param {Object} options An object of options for the Noty plugin
         *
         * @returns {Object} The Noty object created
         */
        createNotification: function(options) {
            var text = options.text;

            // Remove error notification when its already exit in Dom
            if(document.getElementById("noty_top_layout_container")){
                document.getElementById("noty_top_layout_container").remove();
            }

            // Decode all HTML entities
            var elem = document.createElement('textarea');
            elem.innerHTML = text;
            options.text = elem.value;

            return noty(options);
        }
    };
});
